var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3986 3.40255C10.8209 3.03248 9.17908 3.03248 7.60142 3.40255C5.51801 3.89125 3.89125 5.518 3.40255 7.60142C3.03248 9.17908 3.03248 10.8209 3.40255 12.3986C3.89125 14.482 5.51801 16.1087 7.60142 16.5974C9.17908 16.9675 10.8209 16.9675 12.3986 16.5974C14.482 16.1087 16.1087 14.482 16.5974 12.3986C16.9675 10.8209 16.9675 9.17908 16.5974 7.60142C16.1087 5.51801 14.482 3.89125 12.3986 3.40255ZM7.31596 2.18558C9.08133 1.77147 10.9187 1.77147 12.684 2.18558C15.2297 2.7827 17.2173 4.77034 17.8144 7.31596C18.2285 9.08133 18.2285 10.9187 17.8144 12.684C17.2173 15.2297 15.2297 17.2173 12.684 17.8144C10.9187 18.2285 9.08133 18.2285 7.31596 17.8144C4.77035 17.2173 2.7827 15.2297 2.18558 12.6841C1.77147 10.9187 1.77147 9.08133 2.18558 7.31596C2.7827 4.77034 4.77034 2.7827 7.31596 2.18558Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08491 8.08492C8.32899 7.84083 8.72474 7.84083 8.96882 8.08492L9.99999 9.11613L11.0312 8.08492C11.2752 7.84083 11.671 7.84083 11.9151 8.08492C12.1592 8.32899 12.1592 8.72471 11.9151 8.96879L10.8839 9.99996L11.9151 11.0312C12.1592 11.2753 12.1592 11.671 11.9151 11.915C11.671 12.1591 11.2752 12.1591 11.0312 11.915L9.99999 10.8839L8.96882 11.915C8.72474 12.1591 8.32899 12.1591 8.08491 11.915C7.84084 11.671 7.84084 11.2753 8.08491 11.0312L9.11607 9.99996L8.08491 8.96879C7.84084 8.72471 7.84084 8.32899 8.08491 8.08492Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/reject-icon.cae8cd0401de4cf7a5989dcebfae7186.svg";
export { ForwardRef as ReactComponent };